

<div class="dialog-content-wrapper" fxLayout="column">

    <mat-toolbar matDialogTitle class="accent m-0" fxFlex="1 0 auto" fxLayout="row">
  
      <div fxFlex fxLayout="row" fxLayoutAlign="space-between center">
      <div fxLayout="row" fxLayoutAlign="start center">
        <mat-icon class="logo-icon s-32 mr-16">
            message
        </mat-icon>
        <span>{{'NOTIF.TITLE' | translate }}</span>
      
      </div>
        <button mat-icon-button (click)="closeDialog()" aria-label="Close Dialog">
          <mat-icon>close</mat-icon>
        </button>
  
  
      </div>
  
    </mat-toolbar>
  
  
  
    <div mat-dialog-content >
        <p-toast [showTransformOptions]="'translateX(100%)'"></p-toast>

        <form name="notifForm" id="notifForm" #notifForm="ngForm" class="w-100-p" fxLayout="column" fxFlex>

            <div class="p-24" fusePerfectScrollbar  fxLayout="column" >
                
                <mat-form-field appearance="outline" class="w-100-p">
                    <mat-label>{{'NOTIF.NAME' | translate}}</mat-label>
                    <input matInput id="name" name="name" [(ngModel)]="notif.name" #name required>
                </mat-form-field>

                <mat-form-field appearance="outline" class="w-100-p">
                    <mat-label>{{'NOTIF.DESCRIPTION' | translate}}</mat-label>
                    
                    <textarea matInput id="description" name="description"
                    [(ngModel)]="notif.description" required #description [rows]="3"></textarea>
                </mat-form-field>
          
                    <mat-card-content>
                      <!---->  <mat-form-field appearance="outline" class="w-100-p">
                            <mat-label>{{'NOTIF.USER' | translate}}</mat-label>
                            <input matInput id="inputUser" name="inputUser" #inputUser
                                [matAutocomplete]="autoUser" [ngModel]="user">
                            <mat-autocomplete #autoUser="matAutocomplete" id="user" name="user"
                                autoActiveFirstOption (optionSelected)="onUserSelect($event)"
                                [displayWith]="displayUser">
                                <mat-option *ngFor="let itemU of filteredUsers$ | async" [value]="itemU">
                                    {{ itemU.name}}
                                </mat-option>
                                <mat-option *ngIf="
                                (filteredUsers$ | async) &&
                                (filteredUsers$ | async)
                                    .length == 0
                            " style="pointer-events: none">{{
                            "App.NO_VALUE_FOUND" | translate
                            }}</mat-option>
                            </mat-autocomplete>
                        </mat-form-field>
                    
                        <mat-chip-list #chipList id="userAffecter">
                            <mat-chip *ngFor="let itemU of this.notif.users;let i=index" removable="true"
                                selectable="true" (removed)="deleteUser(i)">
                                {{itemU.name}}
                                <mat-icon matChipRemove>cancel</mat-icon>
                            </mat-chip>
                        </mat-chip-list>

                         <mat-form-field appearance="outline" class="w-100-p">
                    <mat-label>{{'NOTIF.GROUPE' | translate}}</mat-label>
                    <input matInput id="inputGroupe" name="inputGroupe" [ngModel]="groupe"
                        [matAutocomplete]="auto"  #inputGroupe >
                    <mat-autocomplete #auto="matAutocomplete" id="groupe" name="groupe" autoActiveFirstOption
                        (optionSelected)="onGroupeSelect($event)" [displayWith]="displayGroupe">
                        <mat-option *ngFor="let item of filteredGroupes$ | async" [value]="item">
                            {{ item.name}}
                        </mat-option>
                        <mat-option *ngIf="
                        (filteredGroupes$ | async) &&
                        (filteredGroupes$ | async)
                            .length == 0
                    " style="pointer-events: none">{{
                    "App.NO_VALUE_FOUND" | translate
                    }}</mat-option>
                    </mat-autocomplete>
                </mat-form-field>
              
                <mat-chip-list #chipList id="groupeAffecter">
                    <mat-chip *ngFor="let item of this.notif.groupes;let i=index" removable="true"
                        selectable="true" (removed)="deleteGroupe(i)">
                        {{item.name}}
                        <mat-icon matChipRemove>cancel</mat-icon>
                    </mat-chip>
                </mat-chip-list>
              
                    </mat-card-content> 
              <!--   </mat-card>-->


              <div mat-dialog-actions class="m-0 p-16" fxLayout="row" fxLayoutAlign="end center">

                <button mat-raised-button id="btn-cancel" class="red mr-8" (click)="closeDialog()">
                  {{'App.CANCEL' | translate}}
                </button>
            
            
            
                <button id="btn-save" mat-button class="light-green fuse-white-fg" (click)="onSubmit(notifForm)">
            
                  <span>{{'App.ADD' | translate}}</span>
                </button>
            
              </div>
            </div>

        </form>
    </div>
    

   

  
  </div>


